var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c(
        "el-header",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen.lock",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true, lock: true },
            },
          ],
          staticClass: "header",
        },
        [
          _c(
            "div",
            {
              style: `width: ${
                _vm.userInfo.ProjectStatus == 1 ? "270px" : "220px"
              };
        font-weight: bold;
        border-right: 1px solid #ccc;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-flow: wrap;
        font-size: 18px;`,
            },
            [
              _vm.isTitle
                ? _c(
                    "div",
                    {
                      staticClass: "HomeTitle",
                      staticStyle: {
                        width: "100%",
                        "text-align": "center",
                        cursor: "pointer",
                      },
                      on: {
                        click: function ($event) {
                          _vm.userInfo.ProjectStatus == 1
                            ? _vm.$router.replace({
                                path: "/ProjectInfo?id=" + _vm.$ProjectId,
                              })
                            : _vm.$router.replace({ path: "/Home" })
                        },
                      },
                    },
                    [_vm._v(" 楼宇设备管理平台 ")]
                  )
                : _vm._e(),
              !_vm.isTitle
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        display: "flex",
                        "justify-content": "space-between",
                        padding: "0px 10px",
                        "align-items": "center",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-back" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.go(-1)
                            },
                          },
                        },
                        [_vm._v(" 后退")]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            display: "flex",
                            "flex-direction": "column",
                            flex: "1",
                            "justify-content": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "text-align": "center" } },
                            [_vm._v("当前功能:")]
                          ),
                          _c(
                            "div",
                            {
                              style: `font-size: ${
                                _vm.RouteName?.title.length > 6
                                  ? "12px"
                                  : "18px"
                              }; text-align: center`,
                            },
                            [_vm._v(" " + _vm._s(_vm.RouteName?.title) + " ")]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { staticClass: "el-menu-demo" },
            [
              _c(
                "Nav",
                [
                  _vm.userInfo.ProjectStatus == 2
                    ? _c(
                        "el-menu",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "default-active": _vm.activeName,
                            mode: "horizontal",
                            router: "",
                            "active-text-color": "#409EFF",
                          },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              class:
                                _vm.activeName === "/HomeInfo" ? "active" : "",
                              attrs: {
                                index: "/HomeInfo",
                                "popper-class": "popper-menu",
                              },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("i", { staticClass: "el-icon-monitor" }),
                                _c("span", [_vm._v("首页")]),
                              ]),
                            ],
                            2
                          ),
                          _vm._l(_vm.Menu, function (item) {
                            return _c(
                              item.children && item.children.length > 0
                                ? "el-submenu"
                                : "el-menu-item",
                              {
                                key: item.title,
                                tag: "component",
                                attrs: {
                                  index: item.path,
                                  "popper-class": "popper-menu",
                                },
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _c("i", { class: [item.icon] }),
                                  _c("span", [_vm._v(_vm._s(item.title))]),
                                ]),
                                item.children && item.children.length > 0
                                  ? _vm._l(item.children, function (val) {
                                      return _c(
                                        val.children && val.children.length > 0
                                          ? "el-submenu"
                                          : "el-menu-item",
                                        {
                                          key: val.title,
                                          tag: "component",
                                          attrs: {
                                            index: val.path,
                                            "popper-class": "popper-menu",
                                          },
                                        },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _c("i", { class: [val.icon] }),
                                            _c("span", [
                                              _vm._v(_vm._s(val.title)),
                                            ]),
                                          ]),
                                          val.children &&
                                          val.children.length > 0
                                            ? _vm._l(
                                                val.children,
                                                function (val2) {
                                                  return _c(
                                                    val2.children &&
                                                      val2.children.length > 0
                                                      ? "el-submenu"
                                                      : "el-menu-item",
                                                    {
                                                      key: val2.title,
                                                      tag: "component",
                                                      attrs: {
                                                        index: val2.path,
                                                        "popper-class":
                                                          "popper-menu",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        { slot: "title" },
                                                        [
                                                          _c("i", {
                                                            class: [val2.icon],
                                                          }),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(val2.title)
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    })
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      )
                    : _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-demo",
                          attrs: {
                            "default-active": _vm.activeName,
                            mode: "horizontal",
                            router: "",
                            "active-text-color": "#409EFF",
                          },
                        },
                        [
                          _c(
                            "el-menu-item",
                            {
                              attrs: {
                                index:
                                  "/ProjectInfo/ProjectAll?id=" +
                                  this.$ProjectId,
                                "popper-class": "popper-menu",
                              },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c("i", { staticClass: "el-icon-monitor" }),
                                _c("span", [_vm._v("工作台")]),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "user" },
            [
              _vm.userInfo.ProjectStatus == 2
                ? _c(
                    "el-dropdown",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { placement: "bottom-start" },
                      on: { command: _vm.openAiView },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            width: "100px",
                            "align-items": "center",
                            cursor: "pointer",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "40px",
                                height: "40px",
                                background: "#409eff",
                                "border-radius": "50%",
                                display: "flex",
                                "align-items": "center",
                                "justify-content": "center",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "20px", height: "20px" },
                                attrs: {
                                  src: require("@/assets/AI.png"),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-left": "5px",
                                "font-weight": "bold",
                                "font-size": "14px",
                                color: "#409eff",
                              },
                            },
                            [_vm._v(" AI助手 ")]
                          ),
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticClass: "aiMenu",
                          staticStyle: { "text-align": "center" },
                          attrs: { slot: "dropdown" },
                          slot: "dropdown",
                        },
                        [
                          _c("el-dropdown-item", { attrs: { command: "b" } }, [
                            _vm._v("设备数据助手"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.userInfo.ProjectStatus == 2
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "14px",
                        width: "110px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c("div", [_vm._v("授权码")]),
                      _c("div", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v(_vm._s(_vm.userInfo.ProjectCode)),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                { on: { click: _vm.openDevAsDrawer } },
                [
                  _c(
                    "el-badge",
                    {
                      staticClass: "badge",
                      attrs: {
                        value: _vm.badgeNum,
                        max: 99,
                        hidden: _vm.badgeNum !== 0 ? false : true,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "ellipsis2",
                          staticStyle: {
                            "font-size": "14px",
                            width: "110px",
                            "text-align": "center",
                          },
                          attrs: {
                            title: _vm.ProjectInfo.Property_Company || "",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.ProjectInfo.Property_Company || "") +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-dropdown",
                {
                  attrs: { size: "medium" },
                  on: { command: _vm.handleCommand },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        margin: "0 10px",
                        display: "flex",
                        "align-items": "center",
                      },
                      on: { click: _vm.handleShowUserInfo },
                    },
                    [
                      _c("el-avatar", {
                        attrs: {
                          size: 40,
                          src:
                            _vm.userInfo.ProjectStatus == 2
                              ? _vm.userInfo.HeadImg || null
                              : _vm.userInfo.Icon || null,
                          icon: "el-icon-user-solid",
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "ellipsis",
                          staticStyle: {
                            "font-size": "14px",
                            "margin-left": "10px",
                            width: "60px",
                          },
                          attrs: {
                            title:
                              _vm.userInfo.ProjectStatus == 2
                                ? _vm.userInfo.RealName || _vm.userInfo.UserName
                                : _vm.userInfo.Person || _vm.userInfo.PMC_Name,
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.userInfo.ProjectStatus == 2
                                  ? _vm.userInfo.RealName ||
                                      _vm.userInfo.UserName
                                  : _vm.userInfo.Person || _vm.userInfo.PMC_Name
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { icon: "el-icon-user", command: "user" } },
                        [_vm._v("用户信息")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: { icon: "el-icon-question", command: "help" },
                        },
                        [_vm._v("帮助")]
                      ),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            icon: "el-icon-switch-button",
                            command: "logout",
                          },
                        },
                        [_vm._v("退出登录")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("el-main", { staticClass: "main" }, [
        _vm.userInfo.ProjectStatus == 1
          ? _c("div", { staticClass: "wh100" }, [_c("router-view")], 1)
          : _vm._e(),
        _vm.userInfo.ProjectStatus == 2
          ? _c("div", { staticClass: "wh100" }, [
              _vm.isShowMenu
                ? _c(
                    "div",
                    {
                      staticClass: "wh100 leftMenu",
                      staticStyle: { display: "flex" },
                    },
                    [
                      _vm.TreeDataType == 1
                        ? _c("DevTreeMenu", { ref: "DevTreeMenu" })
                        : _vm._e(),
                      _vm.TreeDataType == 2
                        ? _c("FittingsTreeMenu", { ref: "FittingsTreeMenu" })
                        : _vm._e(),
                      _vm.TreeDataType == 3
                        ? _c("AssetTreeMenu", { ref: "AssetTreeMenu" })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "rightCenter" },
                        [_c("router-view")],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isShowMenu
                ? _c("div", { staticClass: "wh100" }, [_c("router-view")], 1)
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.AIdrawer,
            modal: false,
            withHeader: false,
            size: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.AIdrawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.AiLoading,
                  expression: "AiLoading",
                },
              ],
              staticStyle: {
                width: "100%",
                height: "100%",
                overflow: "hidden",
              },
            },
            [
              _c("iframe", {
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "min-height": "700px",
                },
                attrs: {
                  src: _vm.AIsrc,
                  frameborder: "0",
                  allow: "microphone",
                  id: "iframe",
                  sandbox: "allow-scripts allow-same-origin",
                },
                on: { load: _vm.handleIframeLoad },
              }),
            ]
          ),
        ]
      ),
      _c("DevDialog", {
        ref: "DevDialog",
        attrs: { type: "radio" },
        on: { select: _vm.handleDevSelect },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.DevAsDrawer,
            size: "80%",
            title: "15天内需年检设备详情",
          },
          on: {
            "update:visible": function ($event) {
              _vm.DevAsDrawer = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "wh100", staticStyle: { padding: "10px" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.DevAsLoading,
                      expression: "DevAsLoading",
                    },
                  ],
                  ref: "table",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.DevAsData, height: "calc(100% - 40px)" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "50", type: "index" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备编号",
                      align: "center",
                      prop: "DeviceCode",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备名称",
                      align: "center",
                      prop: "device_name",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备型号",
                      align: "center",
                      prop: "model_number",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "设备规格",
                      align: "center",
                      prop: "specification",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "生产厂家",
                      align: "center",
                      prop: "manufacturer",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "维修商名称",
                      align: "center",
                      prop: "maintenance",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "安装位置",
                      align: "center",
                      prop: "InstallationAreaName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "供应商",
                      align: "center",
                      prop: "SupplierName",
                      sortable: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "购置日期",
                      align: "center",
                      prop: "purchase_date",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.purchase_date
                                    ? _vm
                                        .moment(scope.row.purchase_date)
                                        .format("YYYY-MM-DD")
                                    : ""
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "年检到期日期",
                      align: "center",
                      prop: "ExpiryDate",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.ExpiryDate
                                    ? _vm
                                        .moment(scope.row.ExpiryDate)
                                        .format("YYYY-MM-DD")
                                    : ""
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.DevAsDrawer = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }